<template>
    <div
      class="modal fade"
      :id="modalId"
      tabindex="-1"
      aria-labelledby="createCategoryModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header border-0">
            <h5 class="modal-title" id="createCategoryModalLabel">{{ title }}</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="onCancel"
            ></button>
          </div>
  
          <!-- Modal Body -->
          <div class="modal-body">
            <form @submit.prevent="onSubmit">
              <div class="mb-3">
                <label class="form-label">{{ $t('category_name') }} <span class="text-danger">*</span></label>
                <input
                  type="text"
                  v-model="categoryName"
                  class="form-control"
                  :placeholder="$t('enter_category_name')"
                />
                <div v-if="error" class="text-danger mt-2">
                  <span>{{ error }}</span>
                </div>
              </div>
            </form>
          </div>
  
          <!-- Modal Footer -->
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="onCancel">
              {{ $t('close') }}
            </button>
            <button type="button" class="btn btn-primary" @click="onSubmit">{{ $t('create') }}</button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import apiUrls from '../../../urls';
  import {useToast} from "vue-toastification";

  export default {
    props: {
      title: {
        type: String,
        default: 'Create Category',
      },

      modalId: {
        type: String,
        required: true,
      },
    },

    setup() {
      const toast = useToast()
      return {toast}
    },

    data() {
      return {
        categoryName: '',
        error: '',
      };
    },
    methods: {
      async onSubmit() {
        if (!this.categoryName) {
          this.error = 'Category name cannot be empty.';
          return;
        }
  
        try {
          const formData = new FormData();
          formData.append('node', this.categoryName);
  
          // Make API call to create a new category
          const response = await this.$axios.post(apiUrls.categories.post, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });

          this.toast.success('Category successfully created!')
          // Reset form and error message
          this.categoryName = '';
          this.error = '';
  
          // Close the modal
          const modal = document.getElementById(this.modalId);
          const modalInstance = bootstrap.Modal.getInstance(modal);
          if (modalInstance){
            // Emit the created category data to the parent
            this.$emit('category-created', response.data);
            modalInstance.hide();
          } 
        } catch (error) {
          if (error.response?.data?.error) {
            this.error = error.response.data.error;
          } else {
            this.error = 'Failed to create category.';
          }
        }
      },
      onCancel() {
        this.$emit('cancel');
      },
    },
  };
  </script>
  
  <style scoped>
  /* Add custom styles if needed */
  </style>